import Button from "../../../../shared/components/Button";
import { getLeagueTexts } from "../../shared/leagueTexts";
import LeagueLayout from "../../shared/components/LeagueLayout";
import LeagueOrganizerAccess from "../components/LeagueOrganizerAccess";
import LeagueEditor from "../components/LeagueEditor";

export default function LeagueEditorPage({ leagueId }: { leagueId?: string }) {
  const t = getLeagueTexts();
  return <LeagueLayout title={leagueId ? t.edit : t.create}>
    <div className="league-actions"><Button href="#/admin/ligas" variant="ghost">{t.manage}</Button></div>
    <LeagueOrganizerAccess><LeagueEditor key={leagueId || "new"} id={leagueId} /></LeagueOrganizerAccess>
  </LeagueLayout>;
}
